import { render, staticRenderFns } from "./fangwu.vue?vue&type=template&id=40eed83e&scoped=true&"
import script from "./fangwu.vue?vue&type=script&lang=js&"
export * from "./fangwu.vue?vue&type=script&lang=js&"
import style0 from "./fangwu.vue?vue&type=style&index=0&id=40eed83e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eed83e",
  null
  
)

export default component.exports